// Commerce Cleanup + KDS Sprint (Feb 2026) — Notification sounds.
// Synthesised via the Web Audio API so the tablet never needs to ship
// or fetch audio assets. Each preset is a tiny envelope around one or
// two oscillators — short, distinct, kitchen-friendly.

let _ctx = null;
function ctx() {
  if (typeof window === "undefined") return null;
  if (_ctx) return _ctx;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  try { _ctx = new AC(); } catch (_e) { return null; }
  return _ctx;
}

function tone({ freq, durationMs, type = "sine", attackMs = 8, releaseMs = 220, gain = 0.18, startInMs = 0 }) {
  const ac = ctx();
  if (!ac) return;
  const now = ac.currentTime + startInMs / 1000;
  const osc = ac.createOscillator();
  const g = ac.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, now);
  g.gain.setValueAtTime(0.0001, now);
  g.gain.exponentialRampToValueAtTime(gain, now + attackMs / 1000);
  g.gain.exponentialRampToValueAtTime(0.0001, now + (attackMs + durationMs + releaseMs) / 1000);
  osc.connect(g).connect(ac.destination);
  osc.start(now);
  osc.stop(now + (attackMs + durationMs + releaseMs) / 1000 + 0.05);
}

export const KDS_SOUND_PRESETS = [
  { id: "chime",  label: "Soft Chime (default)" },
  { id: "bell",   label: "Bell" },
  { id: "ding",   label: "Single Ding" },
  { id: "double", label: "Double Ding" },
  { id: "off",    label: "Off" },
];

export function playKdsSound(presetId) {
  if (!presetId || presetId === "off") return;
  // Some browsers require a user gesture before the AudioContext can run.
  const ac = ctx();
  if (!ac) return;
  if (ac.state === "suspended") {
    try { ac.resume(); } catch (_e) { /* no-op */ }
  }
  switch (presetId) {
    case "bell":
      tone({ freq: 880, durationMs: 120, type: "triangle", releaseMs: 600, gain: 0.20 });
      tone({ freq: 1320, durationMs: 60, type: "sine", attackMs: 12, releaseMs: 500, gain: 0.10, startInMs: 30 });
      break;
    case "ding":
      tone({ freq: 1175, durationMs: 80, type: "sine", releaseMs: 320, gain: 0.22 });
      break;
    case "double":
      tone({ freq: 988, durationMs: 70, type: "sine", releaseMs: 220, gain: 0.20 });
      tone({ freq: 1318, durationMs: 90, type: "sine", releaseMs: 260, gain: 0.20, startInMs: 180 });
      break;
    case "chime":
    default:
      // Soft major-third chime — gentle on the ear, distinct over kitchen noise.
      tone({ freq: 784, durationMs: 90, type: "sine", attackMs: 12, releaseMs: 380, gain: 0.16 });
      tone({ freq: 988, durationMs: 90, type: "sine", attackMs: 12, releaseMs: 420, gain: 0.16, startInMs: 90 });
      break;
  }
}
